import { render } from "./PracticeProducts.vue?vue&type=template&id=4fbf99da&scoped=true"
import script from "./PracticeProducts.vue?vue&type=script&lang=js"
export * from "./PracticeProducts.vue?vue&type=script&lang=js"

import "./PracticeProducts.vue?vue&type=style&index=0&id=4fbf99da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbf99da"]])

export default __exports__